module.exports = __webpack_public_path__ + "media/Burruss Hall Part 3.a8f6938d.mp3";